import { CONSTANTS } from '@toolproof-core/lib/_data/lookups';
import { generateIdentifier } from '@toolproof-core/lib/identifier-generation';

import type { SpaceAdapterRuntimeController } from '@toolproof-core/visualization/adapter/_contract/runtime';

import { createInitialRuntimeState } from '@/workflow-builder/_pure/model/reducer';
import { buildOverlayModel, reduceOverlayIntent } from '@/workflow-builder/interaction/overlay';
import { createExecutionOwner } from '@/workflow-builder/execution';
import { MODE_AUGMENTATION_CONTROLLER } from '@/workflow-builder/modeAugmentation';
import type { CosmosDataModel } from '@/workflow/_contract/cosmosData';
import type { Config } from '@/workflow-builder/_contract/config';
import type { RunWorkflowCapabilities } from '@/workflow-builder/_contract/runWorkflow';
import type { RuntimeState } from '@/workflow-builder/_contract/runtime';

export type { Config } from '@/workflow-builder/_contract/config';

export function createMode(capabilities: RunWorkflowCapabilities) {
    const runtimeController: SpaceAdapterRuntimeController<
        Config,
        RuntimeState,
        CosmosDataModel
    > = {
        createInitialRuntimeState: () => createInitialRuntimeState({
            mutableWorkflow: {
                handle: generateIdentifier(CONSTANTS.Names.WorkflowHandle),
                stepsByThreadIndex: [[]],
                workflowState: {},
            },
            toolMap: new Map(),
        }),
        buildOverlayModel,
        reduceOverlayIntent: (args) => reduceOverlayIntent({
            ...args,
            ...capabilities,
        }),
        reduceDerivationTransitionComplete: ({ runtimeState }) => runtimeState.pendingOverviewNavigation
            ? { ...runtimeState, pendingOverviewNavigation: null }
            : runtimeState,
    };

    return {
        adapterMode: 'builder' as const,
        runtimeController,
        augmentationController: MODE_AUGMENTATION_CONTROLLER,
        createExecutionOwner: () => createExecutionOwner(capabilities),
    };
}
